module.exports = __webpack_public_path__ + "app/components/devices/message-board/new.view.html";